import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import countries from "../data/countries";
import "../styles/AuthModal.css";

const AuthModal = ({ closeModal }) => {
    const { login, register, forgot_password } = useAuth();
    const [screen, setScreen] = useState("login");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [username, setUsername] = useState("");
    const [country, setCountry] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (loading) {
            return;
        }

        setLoading(true);
        setError("");

        try {
            let response;

            if (screen === "login") {
                response = await login(email, password);
            } else if (screen === "register") {
                response = await register(
                    email,
                    password,
                    username,
                    country
                );
            } else {
                response = await forgot_password(email);
            }

            if (response.success) {
                closeModal();
            } else {
                setError(response.message);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div id="auth-modal">
                <h2>{screen === "login" ? "Login" : screen === "register" ? "Register" : "Reset"}</h2>
                {error && <p style={{ color: "red" }}>{error}</p>}
                <form onSubmit={handleSubmit}>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="auth-input"
                        disabled={loading}
                    />
                    {screen !== "forgot-password" && (
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="auth-input"
                            disabled={loading}
                        />
                    )}
                    {screen === "register" && (
                        <>
                            <input
                                type="text"
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="auth-input"
                            />
                            <select
                                value={country}
                                onChange={(e) => setCountry(e.target.value)}
                                className="auth-input"
                            >
                                <option value="">Select Country</option>
                                {countries.map((c, index) => (
                                    <option key={index} value={c}>{c}</option>
                                ))}
                            </select>
                        </>
                    )}
                    <button
                        type="submit"
                        className="auth-submit-btn"
                        disabled={loading}
                    >
                        {loading
                            ? (
                                screen === "login"
                                    ? "Logging in..."
                                    : screen === "register"
                                        ? "Registering..."
                                        : "Sending..."
                            )
                            : (
                                screen === "login"
                                    ? "Login"
                                    : screen === "register"
                                        ? "Register"
                                        : "Reset Password"
                            )
                        }
                    </button>
                    {screen === "login" && (
                        <button type="button" className="forgotten-password-btn" onClick={() => setScreen("forgot-password")}>
                            {"Forgotten password"}
                        </button>
                    )}
                </form>
                <div className="auth-bottom-buttons">
                    <button onClick={() => {
                        setScreen(screen === "login" ? "register" : "login");
                        setError("");
                    }}
                        className="auth-switch-btn"
                    >
                        {screen === "login" ? "Switch to Register" : screen === "register" ? "Switch to Login" : "Back to Login"}
                    </button>
                    <button onClick={closeModal} className="auth-close-btn">Close</button>
                </div>
            </div>
        </div>
    );
};

export default AuthModal;
